import {Component, OnInit} from '@angular/core';
import {ProblemDetails} from '../../../app-common/data/problemDetails';
import {AuthService} from '../../services/auth/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {RegisterTrialRequest} from '../../data/registerTrialRequest';
import {RegexUtils} from '../../../app-common/utils/RegexUtils';
import {AppStateService, AppWindowState} from '../../../app-common/services/appState/app-state.service';
import {PlatformService} from '../../../app-common/services/native/platform.service';


// noinspection AngularMissingOrInvalidDeclarationInModule
@Component({
  selector: 'app-register-trial-page',
  templateUrl: './register-trial-page.component.html',
  styleUrls: ['./register-trial-page.component.scss', '../unauthorized.scss']
})
export class RegisterTrialPageComponent implements OnInit {
  email: string = '';
  password: string = '';
  confirmPassword: string = '';
  firstName: string = '';
  lastName: string = '';
  phoneNumber: string = '';
  companyWebsite: string = '';
  companyName: string = '';
  companyDescription: string = '';
  problemDetails: ProblemDetails<RegisterTrialRequest>;
  isSubmitting: boolean = false;

  constructor(private authService: AuthService,
              private appStateService: AppStateService,
              private platformService: PlatformService,
              private router: Router,
              private route: ActivatedRoute) {
  }

  ngOnInit() {
  }

  get emailValid(): boolean {
    return RegexUtils.emailRegex.test(this.email);
  }

  get companyWebsiteValid(): boolean {
    if (this.companyWebsite.length === 0){
      return undefined;
    }
    return RegexUtils.websiteRegex.test(this.companyWebsite);
  }

  get firstNameValid(): boolean {
    return this.firstName.length > 0;
  }

  get lastNameValid(): boolean {
    return this.lastName.length > 0;
  }

  get phoneNumberValid(): boolean {
    if (this.phoneNumber.length === 0){
      return undefined;
    }
    return RegexUtils.phoneNumberRegex.test(this.phoneNumber) || !RegexUtils.digitsRegex.test(this.phoneNumber);
  }

  get passwordValid(): boolean {
    return this.password.length > 0 && this.password === this.confirmPassword && this.password.length <= 20;
  }

  get isSecondOasswordValid(): boolean {
    return this.password === this.confirmPassword && this.password !== '' && this.confirmPassword !== '';
  }

  get companyNameValid(): boolean {
    return this.companyName.length > 0;
  }

  get companyDescriptionValid(): boolean {
    return true;
    return this.companyDescription.length > 0;
  }

  get isFormValid(): boolean {
    return this.emailValid && this.firstNameValid && this.lastNameValid && this.passwordValid && this.isSecondOasswordValid && this.companyNameValid;
  }

  get isRegisterButtonDisabled(): boolean {
    return !this.isFormValid && !this.isSubmitting;
  }

  async register() {
    if (!this.isFormValid) {
      return;
    }
    if (this.isSubmitting) {
      return;
    }
    this.isSubmitting = true;
    const request: RegisterTrialRequest = {
      accountInformation: {
        username: this.email,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName,
        phoneNumber: RegexUtils.digitsRegex.test(this.phoneNumber) ? this.phoneNumber : '',
        website: this.companyWebsite
      },
      companyInformation: {
        companyName: this.companyName,
        companyDescription: this.companyDescription,
      }
    };
    const response = this.authService.registerTrial(request)
      .then(() => {
        this.router.navigate(['login']);
        this.appStateService.appWindowState = AppWindowState.Login;
        this.platformService.openInBrowser('https://godatahub.com/get-started-confirmation/');
        this.isSubmitting = false;
      })
      .catch(error => {
        this.isSubmitting = false;
        if (error instanceof ProblemDetails) {
          this.problemDetails = error;
        }
      });
  }

  changeStateToLogin() {
    this.appStateService.appWindowState = AppWindowState.Login;
  }
}
